import React from 'react'
import { NumeroVerdeItem, WContainer } from '@components/atoms'
import { Page } from '@components/organisms'
import { useBrandsQuery, useStoresQuery } from '@gql/graphql'
import groupBy from 'lodash/groupBy'
import styles from './ChiamaciTemplate.module.sass'
import useTrans from '@hooks/useTrans'

interface Props {
  pagina?: any
  className?: string
}

const ChiamaciTemplate = (props: Props) => {
  const { pagina = {}, className = '' } = props

  const t = useTrans()

  const { data: brandsData } = useBrandsQuery({ fetchPolicy: 'cache-first' })
  const { data: storesData } = useStoresQuery({ fetchPolicy: 'cache-first' })

  const numeriBrandsGrouped = groupBy(
    brandsData?.brands?.filter((item) => item.numeroVerde) || [],
    'numeroVerde'
  )
  const numeriStoresGrouped = groupBy(
    storesData?.stores?.filter((item) => item.numeroVerde) || [],
    'numeroVerde'
  )

  // grazie McGPT :)
  const orderedNumeriBrandsGrouped = Object.entries(numeriBrandsGrouped)
    .sort((a, b) => b[1].length - a[1].length)
    .reduce((acc, [key, value]) => {
      acc[key] = value
      return acc
    }, {})

  return (
    <Page pagina={pagina} item={{}} contentClassName={styles.chiamaciTemplate}>
      <WContainer variant="sm">
        <div className={styles.container}>
          {(!!pagina.titolo || !!pagina.descrizione) && (
            <div className={styles.head}>
              {!!pagina.titolo && <h1 className={styles.title}>{pagina.titolo}</h1>}
              {!!pagina.descrizione && (
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: pagina.descrizione }}
                />
              )}
            </div>
          )}
          {orderedNumeriBrandsGrouped && (
            <div className={styles.numeri}>
              <h3 className={styles.numeriTitle}>{t('Info prodotti')}</h3>
              <section className={styles.numeriContainer}>
                {Object.entries(orderedNumeriBrandsGrouped).map(([numero, items]) => (
                  <NumeroVerdeItem
                    title={items.map((item) => item.name).join(', ')}
                    number={numero}
                  />
                ))}
              </section>
            </div>
          )}
          {numeriStoresGrouped && (
            <div className={styles.numeri}>
              <h3 className={styles.numeriTitle}>{t('Info acquisti online')}</h3>
              <section className={styles.numeriContainer}>
                {Object.entries(numeriStoresGrouped).map(([numero, items]) => (
                  <NumeroVerdeItem
                    title={items[0].name}
                    image={
                      items[0].image ||
                      'https://vividanone-multisite.webranking.biz/media/filer_public_thumbnails/filer_public/26/9a/269ad0ab-caed-4a06-8d9d-01652e4d7924/mellin.png__75.24x50_q100_crop_subsampling-2.png'
                    }
                    number={numero}
                  />
                ))}
              </section>
            </div>
          )}
        </div>
      </WContainer>
    </Page>
  )
}

export default ChiamaciTemplate
